import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as ImageShopAPI from "@/api/image-shop";
import { CommonResponse, isSuccess } from "@/api/response";
import {
  SortRequest,
  RegisterRequest,
  DeleteRequest
} from "@/api/image-shop/request";

const MODULE_NAME = "image-shop/modify";

/**
 * 公開動画登録更新APIのレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Modify extends VuexModule {
  // state
  commonResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.commonResponse);
  }

  get getMessage() {
    return this.commonResponse.message;
  }

  @MutationAction
  async sort(sortRequest: SortRequest) {
    const commonResponse = await ImageShopAPI.sort(sortRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async register(registerRequest: RegisterRequest) {
    const commonResponse = await ImageShopAPI.register(registerRequest);
    return {
      commonResponse
    };
  }

  // MutationActions
  @MutationAction
  async deleteOne(deleteRequest: DeleteRequest) {
    const commonResponse = await ImageShopAPI.deleteOne(deleteRequest);
    return {
      commonResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      commonResponse: {} as CommonResponse
    };
  }
}

export default getModule(Modify);
